module.exports = __webpack_public_path__ + "img/solution-finance-banner.767e4cd0.jpg";